import {isTaxTypeZero, TaxCombination} from 'utils/tax';

type Unselected = null;
export const UNSELECTED: Unselected = null;

export type ModalFormField = {
    checkDuplicate?: Unselected;
    customTaxRateText: string | Unselected;
    isTaxInclusiveRadio: 'false' | 'true' | Unselected;
    taxRateRadio: '10_pct' | '8_pct' | 'custom' | Unselected;
    taxTypeRadio:
        | 'duty_free'
        | 'legacy_no_tax'
        | 'legacy_tax'
        | 'non_taxable'
        | 'reduced'
        | 'standard'
        | 'untaxable'
        | Unselected;
};

export const DEFAULT_FORM_FIELD: ModalFormField = {
    customTaxRateText: '',
    isTaxInclusiveRadio: UNSELECTED,
    taxRateRadio: UNSELECTED,
    taxTypeRadio: UNSELECTED,
};

export type NoUnselectedField<T extends keyof ModalFormField> = Exclude<
    ModalFormField[T],
    Unselected
>;

export const Deserializer = {
    isTaxInclusive: (
        isTaxInclusiveRadio: NoUnselectedField<'isTaxInclusiveRadio'>,
    ): TaxCombination['isTaxInclusive'] => isTaxInclusiveRadio === 'true',

    taxRate: (
        taxRateRadio: NoUnselectedField<'taxRateRadio'>,
        customTaxRateText: NoUnselectedField<'customTaxRateText'>,
    ): TaxCombination['taxRate'] => {
        if (taxRateRadio === 'custom') {
            return customTaxRateText;
        }

        return taxRateRadio === '10_pct' ? '10' : '8';
    },

    taxType: (
        taxTypeRadio: NoUnselectedField<'taxTypeRadio'>,
    ): TaxCombination['taxType'] => taxTypeRadio,
};

export const trimZeroes = (value: string): string => {
    // No decimal place
    if (!value.includes('.')) {
        return value.replaceAll(/^0+(?=[1-9])/g, '');
    }

    return value
        .replaceAll(/^0+(?=[1-9])/g, '')
        .replaceAll(/0+$/g, '')
        .replaceAll(/\.$/g, '');
};

export const prepareData = (formData: ModalFormField): TaxCombination => {
    const {customTaxRateText, isTaxInclusiveRadio, taxRateRadio, taxTypeRadio} =
        formData;

    const taxType = Deserializer.taxType(
        taxTypeRadio as NoUnselectedField<'taxTypeRadio'>,
    );

    if (isTaxTypeZero(taxType)) {
        return {
            isTaxInclusive: false,
            taxRate: '0',
            taxType,
        };
    }

    const taxRate = Deserializer.taxRate(
        taxRateRadio as NoUnselectedField<'taxRateRadio'>,
        customTaxRateText || '10',
    );
    const isTaxInclusive = Deserializer.isTaxInclusive(
        isTaxInclusiveRadio as NoUnselectedField<'isTaxInclusiveRadio'>,
    );

    return {
        isTaxInclusive,
        taxRate: trimZeroes(taxRate),
        taxType,
    };
};
